<div class="main-tab-title-box">
  <mat-card-title class="main-title">Knowledge-Based Vocabulary List</mat-card-title>
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<mat-card-content>
  <div class="div_scroll_box">
    <div id="button-switch-box">
      <div class="button-container left" [ngClass]="{'selected': isSelected('analysis')}" (click)="selectMenuItem('analysis')">
        <div style="margin-top: 8px;">
          <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;" src="./assets/images/extra_tab_icons/parts-of-speech-icon.svg">
          <span class="main-box-title-14" style="padding-top: 2px;">Analysis</span>
        </div>
      </div>
      <ng-container *ngIf="checked">
        <div class="separator"></div>
        <div class="button-container" [ngClass]="{'selected': isSelected('summary')}" (click)="selectMenuItem('summary')">
          <div style="margin-top: 9px;">
            <span class="main-box-title-14">Summary</span>
          </div>
        </div>
        <div class="separator"></div>
        <div class="button-container" [ngClass]="{'selected': isSelected('tokens')}" (click)="selectMenuItem('tokens')">
          <div style="margin-top: 8px;">
            <img class="img-estimates" src="./assets/images/extra_tab_icons/tokens-icon.svg">
            <span class="main-box-title-14" style="padding-top: 2px;">Estimates</span>
          </div>
        </div>
      </ng-container>
      <div class="separator"></div>
      <div class="button-container right" [ngClass]="{'selected': isSelected('charts')}" (click)="selectMenuItem('charts')">
        <div style="margin-top: 8px;">
          <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;" src="./assets/images/extra_tab_icons/charts-icon.svg">
          <span class="main-box-title-14" style="padding-top: 2px;">Charts</span>
        </div>
      </div>
    </div>
  </div>
  <!------------------------------------>
  <!------------------------------------>
  <!-------------ANALYSIS--------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'analysis'">
    <span class="main-box-title-14">The Knowledge-based Vocabulary Lists (KVL) are the outcome of a collaborative
      British Council sponsored research project. <br>
      <br>
      The KVL lists were created by testing English language word knowledge of over 100,000 Chinese, German, and Spanish
      learners of English in order to determine which words were known best and which were less well known. The test
      required the learners to spell the words correctly, and so required a good level of mastery. <br>
      <br>
      Based on this information, the KVL lists provide a rank order of difficulty (from easier to more difficult) for
      the best known 5,000 English language words for participants from the three language backgrounds.</span>

    <div id="box">
      <div style="margin-right: 20px;">
        <div class="select-container">
          <label class="main-box-title-14" for="englishType">Learners' native language</label>
          <select id="nativeLanguage" name="nativeLanguage" class="custom-select" [(ngModel)]="selectedLanguage"
          (change)="onLanguageChange(); " [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
            <option value="es">Spanish</option>
            <option value="de">German</option>
            <option value="cn">Chinese</option>
          </select>
        </div>
      </div>

      <div>
        <div class="select-container">
          <label class="main-box-title-14 tem-padding" for="englishType">Bucket Size</label>
          <select id="bucketSize" name="bucketSize" class="custom-select" [(ngModel)]="selectedSize"
          (change)="onLanguageChange();" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
            <option value="100">100</option>
            <option value="250">250</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        </div>
      </div>
    </div>
    
    <div id="buttons-box">

      <button mat-button *ngIf="!hideEyeIconsForSafari1561" style="margin-left: 4px;" style="visibility: hidden; display: inline-block;">
        <img class="eye-icon" style="margin-right: 2px; padding-bottom: 2px;" src="./assets/images/eye-icon.svg">
        <span class="main-box-title-12">See All</span>
      </button>

      <span style="padding-left: 15px;">
        <button [matMenuTriggerFor]="fileMenu" class="icon-button" (click)="toggleIcon()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">

          <span class="button-export"><div><img src="../assets/images/export-con.svg" class="export-con"></div><span>Lexis: KVL
            Export</span></span>
          <mat-icon class="right-icon" [ngClass]="{'rotated-icon': isIconRotated, 'normal-icon': !isIconRotated}">expand_more</mat-icon>
        </button>
        <mat-menu #fileMenu="matMenu" (closed)="resetIcon()" xPosition="before">
          <button mat-menu-item (click)="export_detallado()">Export Detailed Analysis</button>
          <button mat-menu-item (click)="export_tagger()">Export Tagged Data</button>
        </mat-menu>
      </span>

    </div>
    <div class="knowledge-rank-title">Knowledge Rank</div>
    <div class="content-show-all">
      <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
        {{ showAll ? 'Expand all' : 'Contract all' }}
      </button>
    </div>
    <div class="div_scroll_box">
    <ng-container *ngFor="let item of rank_data; let i = index">
      
      <div class="vertical-box" *ngIf="item.cantidad != 0">
        <div class="horizontal-box" style="border: none; margin-bottom: 0px; cursor: pointer;" (click)="toggleExpand(item.label)" [ngClass]="{'expanded': isExpanded[item.label]}">
          <div class="main-box-title-14"> 
            <img class="eye-icon" *ngIf="!ishighlighted[item.label] && !hideEyeIconsForSafari1561" (click)="toggleEyeIcon(item.label,i ); $event.stopPropagation()" src="../../assets/images/eye-icon.svg">
            <img class="eye-icon" *ngIf="ishighlighted[item.label]  && !hideEyeIconsForSafari1561" (click)="toggleEyeIcon(item.label,i ); $event.stopPropagation()" src="../../assets/images/yellow_icons/eye-on-icon.svg">
            <span id="box-score-white">{{item.label}}</span> {{item.cantidad}} words ({{item.text | percent: '.2'}} of text)<ng-container *ngIf="checked">(cumul%: {{item.cumul | percent: '.2'}})</ng-container></div>  
          <mat-icon class="expand-icon">expand_more</mat-icon>
        </div>
          <div class="words-content" *ngIf="isExpanded[item.label]">
            <ng-container *ngFor="let palabra of getObjectKeys(item['words'])">
              <div class="item-listado-palabras">
                <b>{{item['words'][palabra]['value']}}</b>&nbsp; {{palabra}}&nbsp; ({{item['words'][palabra]['score']}}) &nbsp;<b>{{item['words'][palabra]['tagger']}}</b>
              </div>
            </ng-container>
          </div>
      </div>
    </ng-container>
    </div>
        
  </ng-container>
  <!------------------------------------>
  <!------------------------------------>
  <!-------------SUMMARY---------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'summary'">
    <div class="select-container" style="margin-bottom: 18px;">
      <label class="main-box-title-14" for="englishType">Learners' native language</label>
      <select id="nativeLanguage" name="nativeLanguage" class="custom-select" [(ngModel)]="selectedLanguage"
      (change)="onLanguageChange();" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
        <option value="es">Spanish</option>
        <option value="de">German</option>
        <option value="cn">Chinese</option>
      </select>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Coverage</div>
      <div class="main-box-value-16-bold summary-value">{{summary.coverage.value ? summary.coverage.value : "--"}}% ({{summary.coverage.counted ? summary.coverage.counted : "--"}} counted / {{summary.coverage.no_counted ? summary.coverage.no_counted : "--"}} not counted)</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Tokens (total items)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.tokens ? summary.tokens : "--"}} ({{summary.tokens_counted ? summary.tokens_counted : "--"}} counted)</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Types (unique items)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.types ? summary.types : "--"}} ({{summary.types_counted ? summary.types_counted : "--"}} counted)</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Elements (includes homonyms)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.elements ? summary.elements : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Total KVL Knowledge Rank (KR) (tokens)
        <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">This statistic is a summation of all of the rankings of the tokens you inputted, according to the KVL. For example, on the Spanish KVL list 'dance' is ranked 1 and 'class' is ranked 44, so if you inputted 'dance class' into Text Inspector you would get a total KVL Knowledge Rank of 45 (1 + 44).</span>
        </div>
      </div>
      <div class="main-box-value-16-bold summary-value">{{summary.total_tokens ? summary.total_tokens : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Total KVL Knowledge Rank (KR) (types)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.total_types ? summary.total_types : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Mean KR per token</div>
      <div class="main-box-value-16-bold summary-value">{{summary.mean_token ? summary.mean_token : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Mean KR per type</div>
      <div class="main-box-value-16-bold summary-value">{{summary.mean_type ? summary.mean_type : "--"}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14 summary-title" >Mean KR per 100 tokens</div>
      <div class="main-box-value-16-bold summary-value">{{summary.mean_100_tokens ? summary.mean_100_tokens : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.fifty_types">
      <div class="main-box-title-14 summary-title" >50th Percentile (types)
        <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">This ranks all the unique words in your text, according to how commonly used they are in the KVL, and takes the medium word (also called the 50th percentile). The number shown here is the position (within all the words in the KVL) of that 50th percentile word. </span>
        </div>
      </div>
      <div class="main-box-value-16-bold summary-value">{{summary.fifty_types ? summary.fifty_types : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.sixty_types">
      <div class="main-box-title-14 summary-title" >60th Percentile (types)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.sixty_types ? summary.sixty_types : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.seventy_types">
      <div class="main-box-title-14 summary-title" >70th Percentile (types)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.seventy_types ? summary.seventy_types : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.eighty_types">
      <div class="main-box-title-14 summary-title" >80th Percentile (types)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.eighty_types ? summary.eighty_types : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.fifty_tokens">
      <div class="main-box-title-14 summary-title" >50th Percentile (tokens)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.fifty_tokens ? summary.fifty_tokens : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.sixty_tokens">
      <div class="main-box-title-14 summary-title" >60th Percentile (tokens)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.sixty_tokens ? summary.sixty_tokens : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.seventy_tokens">
      <div class="main-box-title-14 summary-title" >70th Percentile (tokens)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.seventy_tokens ? summary.seventy_tokens : "--"}}</div>
    </div>
    <div class="horizontal-box" *ngIf="summary.eighty_tokens">
      <div class="main-box-title-14 summary-title" >80th Percentile (tokens)</div>
      <div class="main-box-value-16-bold summary-value">{{summary.eighty_tokens ? summary.eighty_tokens : "--"}}</div>
    </div>
  </ng-container>
  <!------------------------------------>
  <!------------------------------------>
  <!--------------TOKENS---------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'tokens'">
    <div class="select-container" style="margin-bottom: 18px;">
      <label class="main-box-title-14" for="englishType">Learners' native language</label>
      <select id="nativeLanguage" name="nativeLanguage" class="custom-select" [(ngModel)]="selectedLanguage"
      (change)="onLanguageChange();" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
        <option value="es">Spanish</option>
        <option value="de">German</option>
        <option value="cn">Chinese</option>
      </select>
    </div>
    <span style="font-size: 18px;">Tokens estimated: <span class="main-box-value-16-bold">{{total_tokens_estimated}}</span></span>
    <div id="kvl-box">
      <div class="kvl-title">Word</div>
      <div style="width: 20px; height: 20px;"></div>
      <div class="kvl-title">Tag</div>
      <div style="width: 80px; height: 20px;"></div>
      <div class="kvl-title">Count</div>
    </div>
    <div *ngFor="let wordItem of tokenWords" class="horizontal-box">
      <div class="main-box-title-14" id="div_word">{{ wordItem.word }}</div>
      <div class="main-box-title-14" id="div_tag">{{ wordItem.tag }}</div>
      <div style="width: 140px; height: 20px;"></div>
      <div class="main-box-value-16-bold">{{ wordItem.count }}</div>
    </div>
    <!-- <div class="content-show-all">
      <button mat-button style="color:#EEA21A">
        Expand all
      </button>
    </div> -->
  </ng-container>
  <!------------------------------------>
  <!------------------------------------>
  <!--------------CHARTS---------------->
  <!------------------------------------>
  <!------------------------------------>
  <!------------------------------------>
  <ng-container *ngIf="selectedMenuItem === 'charts'">
    <div id="box" style="margin-top: 2px; margin-bottom: 18px; padding: 0px;">
      <div style="margin-right: 20px;">
        <div class="select-container">
          <label class="main-box-title-14" for="englishType">Learners' native language</label>
          <select id="nativeLanguage" name="nativeLanguage" class="custom-select" [(ngModel)]="selectedLanguage"
          (click)="clearChartLanguage()" (change)="onLanguageChange();" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
            <option value="es">Spanish</option>
            <option value="de">German</option>
            <option value="cn">Chinese</option>
          </select>
        </div>
      </div>

      <div>
        <div class="select-container">
          <label class="main-box-title-14 tem-padding" for="englishType">Bucket Size</label>
          <select id="bucketSize" name="bucketSize" class="custom-select" [(ngModel)]="selectedSize"
          (click)="clearChartSize()" (change)="onLanguageChange();" [disabled]="isButtonDisabled()" [ngClass]="{'disabled-button': isButtonDisabled()}">
            <option value="100">100</option>
            <option value="250">250</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        </div>
      </div>
    </div>
    
   
          <div class="chart-container" >
            <div
              class="title-chart">
              Knowledge Rank %</div>
              <div
              class="title-chart-vertical">
              Types %</div>
              <div class="scroll_chart" *ngIf="selectedSize == 100">
                <div class="size_chart_100" >
                <canvas *ngIf="showChartContainer" style="width: 100%; height: 300px; ;margin-left: 1.5%; padding-bottom: 10px;" baseChart
                  [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
                </canvas>
              </div>
              </div>
              <div class="scroll_chart" *ngIf="selectedSize == 250">
                <div class="size_chart_250">
                <canvas *ngIf="showChartContainer" style="width: 100%; height: 300px; ;margin-left: 3%; padding-bottom: 10px;" baseChart
                  [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
                </canvas>
              </div>
              </div>
              <div class="scroll_chart" *ngIf="selectedSize == 500">
                <div class="size_chart_500" >
                <canvas *ngIf="showChartContainer" style="width: 100%; height: 300px; ;margin-left: 5%; padding-bottom: 10px;" baseChart
                  [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
                </canvas>
              </div>
              </div>
              <div class="scroll_chart"  *ngIf="selectedSize == 1000">
                <div class="size_chart_1000">
                  <canvas *ngIf="showChartContainer" style="width: 100%; height: 350px; margin-left: 10%;margin-right: 8%; padding-bottom: 10px;" baseChart
                  [data]="barChartData" [options]="barChartOptions" [type]="barChartType "></canvas>
                </div>
            </div>
              <div  *ngIf="!showChartContainer && selectedSize == 1000" class="div_loader_pag2">
             
                <div  id="div_loader_pag2">
                  <div  class="loader_pag2"></div>
                </div>
                <div class="main-box-title-12">Please wait</div>
              </div>
               <div  *ngIf="!showChartContainer && selectedSize != 1000" class="div_loader_pag">
             
                <div  id="div_loader_pag">
                  <div  class="loader_pag"></div>
                </div>
                <div class="main-box-title-12">Please wait</div>
              </div>
            </div>
        
    
  </ng-container>

  <ng-container *ngIf="!checked">
    <div class="text-box-bottom-simple-mode">
      <div class="line-box-bottom-simple-mode">
        <div class="bottom-text-line-simple-mode"></div>
      </div>
      <span class="main-box-title-14">To see full statistics, switch to “Advanced Mode”.</span>
    </div>
  </ng-container>

</mat-card-content>
